import { render } from "./AlertMain.vue?vue&type=template&id=c68c3840"
import script from "./AlertMain.vue?vue&type=script&lang=js"
export * from "./AlertMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__